import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null,
  accessToken: null,
  logoutInitiated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload.userInfo;
      state.accessToken = action.payload.accessToken;
      state.logoutInitiated = false;
    },
    logout: (state, action) => {
      state.userInfo = null;
      state.accessToken = null;
      state.logoutInitiated = true;
    },
    // updateUserInfo: (state, action) => {
    //   state.userInfo = action.payload.userInfo;
    //   state.logoutInitiated = false;
    // },
    refreshAccessTokenSuccess: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.logoutInitiated = false;
    },
    resetLogoutFlag(state) {
      state.logoutInitiated = false;
    },
    setStreaming: (state, action) => {
      state.isStreaming = action.payload.isStreaming;
    },
  },
});

export const {
  setCredentials,
  logout,
  refreshAccessTokenSuccess,
  resetLogoutFlag,
  setStreaming,
} = authSlice.actions;

export default authSlice.reducer;
